<template>
  <el-drawer :title="title" v-model="visible" destroy-on-close size="500px">
    <el-form label-width="145px" ref="wageWorkType" :model="wageWorkType" :rules="rules">
      <el-form-item label="工种:" prop="workTypeId">
        <el-cascader :options="typeOfWorks" :props="typeOfWorkProps" v-model="wageWorkType.workTypeId" placeholder="工种" />
      </el-form-item>
      <el-form-item label="工资参考上限(元):" prop="salaryUpperLimit">
        <el-input-number v-model="wageWorkType.salaryUpperLimit" :precision="2" :step="1" :min="0"></el-input-number>
      </el-form-item>
      <el-form-item label="正常工资(元):">
        <el-input-number v-model="wageWorkType.normalSalary" :precision="2" :step="1" :min="0"></el-input-number>
      </el-form-item>
      <el-form-item label="加班工资(元):">
        <el-input-number v-model="wageWorkType.overtimeSalary" :precision="2" :step="1" :min="0"></el-input-number>
      </el-form-item>
      <el-form-item label="排序:">
        <el-input-number v-model="wageWorkType.sort" :precision="0" :step="1" :min="1"></el-input-number>
      </el-form-item>
      <el-form-item label="备注:">
        <el-input type="textarea" :maxlength="500" v-model="wageWorkType.remarks" :rows="5"></el-input>
      </el-form-item>
    </el-form>
    
    <template #footer>
      <div style="flex: auto">
        <el-button @click="visible = false" v-loading="saveLoading">取消</el-button>
        <el-button type="primary" @click="save" v-loading="saveLoading">保存</el-button>
      </div>
    </template>
  </el-drawer>
</template>

<script>
import { getItemByTypeCode } from '@/api';
import { deepClone } from '@/utils/common';
import { defineComponent } from 'vue'
import { saveOrUpdateWageWorkType } from '@/api/sys/wageWorkType'

export default defineComponent({
  emits: ['get-data'],
  data() {
    return {
      typeOfWorks: [],
      typeOfWorkProps: {
        checkStrictly: true,
        emitPath: false,
        value: "id",
        label: "name",
      },
      title: '',
      wageWorkType: {},
      visible: false,
      saveLoading: false,
      rules: {
        workTypeId: [{required: true, message: '请选择工种'}],
        salaryUpperLimit: [{required: true, message: '请输入工资参考上限（元）'}]
      }
    }
  },
  props: {
    modelValue: Boolean
  },
  methods: {
    getTypeOfWorks() {
      getItemByTypeCode("work").then(({ data }) => {
        this.typeOfWorks = data.data;
      });
    },
    toShow(wageWorkType) {
      this.title = wageWorkType ? '编辑工种工资' : '新增工种工资';
      if (wageWorkType) {
        this.wageWorkType = deepClone(wageWorkType);
      } else {
        this.wageWorkType = {
          salaryUpperLimit: 0,
          normalSalary: 0,
          overtimeSalary: 0,
          sort: 1
        };
      }
      this.getTypeOfWorks();
      this.visible = true;
    },
    save() {
      this.$refs.wageWorkType.validate(valid => {
        if (valid) {
          this.saveLoading = true;
          saveOrUpdateWageWorkType(this.wageWorkType).then(({data}) => {
            if (data.status) {
              this.$message.success(data.msg);
              this.visible = false;
              this.$emit('get-data');
            } else {
              this.$message.warning(data.msg);
            }
            this.saveLoading = false;
          }).catch(_ => this.saveLoading = false);
        }
      })
    }
  }
})
</script>

<style lang="scss" scoped>

</style>